<template>
  <div class="civii-accordion civii-calendar" style="text-align: center;">
    <div class="civii-accordion-block">
      <div class="civii-accordion-title"
        @click="view = 0">
        <input ref="yearInput" class="civii-calendar-input"
          v-show="yearEditable" type="text" @blur="checkYear"
          @keyup.enter="checkYear" v-model.number="inputYear">
        <div @dblclick="dblclick('year')"
          v-show="!yearEditable">
          {{year}}
        </div>
      </div>
      <div v-show="view === 0"
        class="civii-accordion-item"
        :class="{opened: view === 0}">
        <div class="civii-calendar-flex">
          <div class="civii-calendar-flex-item"
            v-for="(nyear, j) in yearsArray" :key="'nyear' + j"
            @click="selectYear(nyear)"
            :class="{
              selected: year === nyear.year,
              disabled: !nyear.allowed
            }"
          >
            {{nyear.year}}
          </div>
        </div>
      </div>
    </div>
    <div class="civii-accordion-block">
      <div class="civii-accordion-title"
        @click="view = 1">
        <input ref="monthInput" class="civii-calendar-input"
          v-show="monthEditable" type="text" v-model.number="inputMonth"
          @blur="checkMonth" @keyup.enter="checkMonth">
        <div @dblclick="dblclick('month')"
          v-show="!monthEditable">
          {{contents.monthsFull[month - 1]}}
        </div>
      </div>
      <div v-show="view === 1"
        class="civii-accordion-item"
        :class="{opened: view === 1}">
        <div class="civii-calendar-flex">
          <div class="civii-calendar-flex-item"
            v-for="(nmonth, j) in monthsArray" :key="'nmonth' + j"
            @click="selectMonth(nmonth, j)"
            :class="{
              selected: j + 1 === month,
              disabled: !nmonth.allowed
            }"
          >
            {{nmonth.month}}
          </div>
        </div>
      </div>
    </div>
    <div class="civii-accordion-block">
      <div class="civii-accordion-title civii-calendar-daytitle"
        @click="view = 2">
        <div style="width: 40px;" @click="moveMonth(-1)">❮</div>
        <input ref="dayInput" class="civii-calendar-input"
          v-show="dayEditable" type="text" v-model.number="inputDay"
          @blur="checkDay" @keyup.enter="checkDay">
        <div @dblclick="dblclick('day')"
          v-show="!dayEditable">{{day}}</div>
        <div style="width: 40px;" @click="moveMonth(1)">❯</div>
      </div>
      <div v-show="view === 2" style="padding: 10px;"
        class="civii-accordion-item"
        :class="{opened: view === 2}">
        <table style="width: 100%; border-spacing: 0;table-layout: fixed;">
          <tr>
            <th v-for="(day, i) in contents.days"
              :key="'dayn' + i">
              {{day}}
            </th>
          </tr>
          <tr v-for="(week, i) in calendar" :key="'week' + i">
            <td v-for="(nday, j) in week" :key="'day' + j">
              <div :title="nday.comment" class="civii-calendar-day"
                @click="selectDay(nday)"
                :class="{
                  highlight: nday.highlight,
                  selected: nday.day === day,
                  disabled: !nday.allowed
                }"
              >
                {{nday.day}}
              </div>
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import accordion from '../Accordion/Accordion.vue'

export default {
  components: {
    accordion
  },
  props: {
    value: Object,
    locale: {type: String, default: 'es-es'},
    inverted: {type: Boolean, default: false}, // TODO: modificar para que se pueda utilizar inverted = true
    allow: Object,
    highlight: Object,
    comments: Object
  },
  data () {
    return {
      view: 2,
      contents: {days: [], months: [], monthsFull: []},
      calendar: [],
      context: {},
      yearEditable: false,
      monthEditable: false,
      dayEditable: false,
      year: null,
      month: null,
      day: null,
      yearsSpan: 10,
      inputYear: null,
      inputMonth: null,
      inputDay: null,
      loading: false
    }
  },
  computed: {
    yearsArray () {
      let i = this.year - this.yearsSpan
      let yearsArray = []
      for (i; i < this.year + this.yearsSpan; i++) {
        let allowed = !this.context.hasOwnProperty(i) !== !this.inverted
        yearsArray.push({year: i, allowed})
      }
      return yearsArray
    },
    monthsArray () {
      let self = this
      let context = this.context[this.year]
      return this.contents.monthsFull.map(function (month, index) {
        let allowed = !context.hasOwnProperty(index + 1) !== !self.inverted
        return {month, allowed}
      })
    }
  },
  watch: {
    value: 'updateAll',
    locale: 'updateLanguage',
    year () {
      this.inputYear = this.year
      let c = this.context[this.year]
      if (typeof c === 'object' && c != null) {
        if (!c.hasOwnProperty(this.month)) {
          this.month = parseInt(Object.keys(c)[0])
        }
      } else this.month = null
      this.updateDaysView()
      this.$emit('input', {year: this.year, month: this.month, day: this.day})
    },
    month () {
      this.inputMonth = this.month
      let c = {}
      try {
        c = this.context[this.year][this.month]
      } catch (e) {}
      if (typeof c === 'object' && c != null) {
        if (!c.hasOwnProperty(this.day)) {
          this.day = parseInt(Object.keys(c)[0])
        }
      } else this.day = null
      this.updateDaysView()
      this.$emit('input', {year: this.year, month: this.month, day: this.day})
    },
    day () {
      this.inputDay = this.day
      this.$emit('input', {year: this.year, month: this.month, day: this.day})
    },
    allow: 'updateContext',
    hightlight: 'updateContext',
    comments: 'updateContext'
  },
  methods: {
    selectYear (year) {
      if (year.allowed) this.year = year.year
    },
    selectMonth (month, index) {
      if (month.allowed) this.month = index + 1
    },
    selectDay (day) {
      if (day.allowed) this.day = day.day
    },
    fixMonth (year, month, step) {
      if (month === 12 && step > 0) {
        month = 1
        year += 1
      } else if (month === 1 && step < 0) {
        month = 12
        year -= 1
      } else {
        month += step
      }
      return {year, month}
    },
    moveMonth (step) {
      if (this.loading) return
      this.loading = true
      let val = this.year + this.month / 12
      let c = this.context
      let years = Object.keys(c).sort()
      if (step < 0) years.reverse()

      for (let year of years) {
        let months = Object.keys(c[year]).sort()
        if (step < 0) months.reverse()
        for (let month of months) {
          let newVal = year / 1 + month / 12
          if ((step > 0 && (val < newVal)) || (step < 0 && (val > newVal))) {
            this.year = parseInt(year)
            this.month = parseInt(month)
            this.loading = false
            return
          }
        }
      }
      this.loading = false
    },
    checkYear () {
      if (this.context.hasOwnProperty(this.inputYear)) this.year = this.inputYear
      else this.inputYear = this.year
      this.yearEditable = false
    },
    checkMonth () {
      let c = this.context[this.year]
      if (c != null && c.hasOwnProperty(this.inputMonth)) {
        this.month = this.inputMonth
      } else this.inputMonth = this.month
      this.monthEditable = false
    },
    checkDay () {
      let allowed = false
      try {
        allowed = !!this.context[this.year][this.month][this.inputDay].allowed
      } catch (e) {}
      if (allowed) {
        this.day = this.inputDay
      } else this.inputDay = this.day
      this.dayEditable = false
    },
    updateAll () {
      let year = parseInt(this.value.year) || this.year
      let month = parseInt(this.value.month) || this.month
      let day = parseInt(this.value.day) || this.day
      let c = {}
      try {
        c = this.context[year][month]
      } catch (e) {}
      if (c.hasOwnProperty(day) && c[day].allowed) {
        this.year = year
        this.month = month
        this.day = day
      }
    },
    dblclick (item) {
      this[item + 'Editable'] = true
      this.$nextTick(function () {
        this.$refs[item + 'Input'].focus()
      })
    },
    updateLanguage () {
      this.contents.days = []
      for (let i = 1; i < 8; i++) {
        let date = new Date(2018, 3, i)
        this.contents.days.push(date.toLocaleString(
          this.locale, { weekday: 'long' })
          .toUpperCase().slice(0, 2))
      }
      this.contents.months = []
      this.contents.monthsFull = []
      for (let i = 0; i < 12; i++) {
        let date = new Date(2018, i)
        this.contents.months.push(date.toLocaleString(
          this.locale, { month: 'short' }))
        this.contents.monthsFull.push(date.toLocaleString(
          this.locale, { month: 'long' }))
      }
    },
    updateDaysView () {
      this.calendar = []
      if (this.year && this.month) {
        let ndays = new Date(this.year, this.month, 0).getDate()

        let weekday = new Date(this.year, this.month - 1, 1).getDay()
        let weeks = Math.ceil((weekday + ndays) / 7)
        let context = {}
        context = this.context[this.year][this.month]
        // if (this.context.hasOwnProperty(this.year) &&
        //   this.context[this.year].hasOwnProperty(this.month)) {
        //   context = this.context[this.year][this.month]
        // }
        if (!context.hasOwnProperty(this.day)) {
          this.day = parseInt(Object.keys(context)[0])
        }
        let n = -weekday + 1
        for (let i = 0; i < weeks; i++) {
          let week = []
          for (let j = 0; j < 7; j++) {
            let obj = {}
            if (n > 0 && n <= ndays) {
              obj = (context[n] === undefined) ? {} : context[n]
              obj.allowed = !obj.allowed !== !this.inverted
              obj.day = n
            }
            week.push(obj)
            n++
          }
          this.calendar.push(week)
        }
      } else {
        this.calendar.push([])
      }
    },
    updateContext () {
      this.context = {}
      for (let year in this.allow) {
        if (!this.context[year]) this.context[year] = {}
        for (let month in this.allow[year]) {
          if (!this.context[year][month]) this.context[year][month] = {}
          for (let day of this.allow[year][month]) {
            if (!this.context[year][month][day]) this.context[year][month][day] = {}
            this.context[year][month][day].allowed = true
          }
        }
      }
      for (let year in this.highlight) {
        if (!this.context[year]) this.context[year] = {}
        for (let month in this.highlight[year]) {
          if (!this.context[year][month]) this.context[year][month] = {}
          for (let day of this.highlight[year][month]) {
            if (!this.context[year][month][day]) this.context[year][month][day] = {}
            this.context[year][month][day].highlight = true
          }
        }
      }
      for (let year in this.comments) {
        if (!this.context[year]) this.context[year] = {}
        for (let month in this.comments[year]) {
          if (!this.context[year][month]) this.context[year][month] = {}
          for (let day in this.comments[year][month]) {
            if (!this.context[year][month][day]) this.context[year][month][day] = {}
            this.context[year][month][day].comment = this.comments[year][month][day]
          }
        }
      }
    }
  },
  async mounted () {
    await this.updateContext()
    let year = null
    let month = null
    let day = null

    if (!this.inverted) {
      if (Object.keys(this.context).length > 0) {
        year = Math.min(...Object.keys(this.context))
        let context = this.context[year]
        if (Object.keys(context).length > 0) {
          month = Math.min(...Object.keys(context))
          context = context[month]
          if (Object.keys(context).length > 0) {
            for (let nday in context) {
              if (context[nday].allowed) {
                day = nday
                break
              }
            }
          }
        }
      }
    }
    this.year = year
    this.month = month
    this.day = day
    this.updateLanguage()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/widgets/Calendar/Calendar.vue